"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../constants");
var localization_1 = require("../components/localization");
var lodash_isequal_1 = __importDefault(require("lodash.isequal"));
var lodash_pick_1 = __importDefault(require("lodash.pick"));
var lodash_merge_1 = __importDefault(require("lodash.merge"));
var lodash_pickby_1 = __importDefault(require("lodash.pickby"));
var default_1 = /** @class */ (function () {
    function default_1() {
    }
    default_1.getContext = function (context) {
        return constants_1.CONTEXTS.find(function (_a) {
            var key = _a.key, description = _a.description, rest = __rest(_a, ["key", "description"]);
            var templateKeys = Object.keys(rest);
            var missingKeys = lodash_pickby_1.default(rest, function (value) { return value === undefined; });
            var contextWithMissingKeys = lodash_merge_1.default({}, missingKeys, context);
            return lodash_isequal_1.default(rest, lodash_pick_1.default(contextWithMissingKeys, templateKeys));
        });
    };
    default_1.getContextTitle = function (context, isGetDescription) {
        if (isGetDescription === void 0) { isGetDescription = false; }
        var contextTemplate = this.getContext(context);
        var translationKey = contextTemplate === null || contextTemplate === void 0 ? void 0 : contextTemplate.key;
        if (isGetDescription) {
            translationKey = (contextTemplate === null || contextTemplate === void 0 ? void 0 : contextTemplate.description) || translationKey;
        }
        if (translationKey) {
            return localization_1.localize(translationKey);
        }
    };
    return default_1;
}());
exports.default = default_1;
